import script from "./splitpanes.vue?vue&type=script&lang=js"
export * from "./splitpanes.vue?vue&type=script&lang=js"

import "./splitpanes.vue?vue&type=style&index=0&id=c12035ea&lang=scss"

const __exports__ = script;

export default __exports__